import { React, useState } from 'react';
import {  Card, Form, Stack, Button } from 'react-bootstrap';
import * as api from 'services/api';
import { useTranslation } from 'react-i18next';
export function Password({ handleReseted }) {
    const { t } = useTranslation();
  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setPasswordData({
      ...passwordData,
      [name]: value,
    });
  };

  const isStrongPassword = (password) => {
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+}{"':;?/>.<,])(?=.{9,})/;
    return passwordRegex.test(password);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const { newPassword, confirmPassword, oldPassword } = passwordData;
    if (newPassword !== confirmPassword) {
        setError(t('prPassNotMatch'));
      return;
    } 

    if (!isStrongPassword(newPassword)) {
        setError(t('usPassRequirements'));
      return;
    }

    const response = await api.updatePassword(oldPassword, newPassword);
      if (response.status !== 200) {
          setError(response.data.message);
      } else {
          setError('');
          handleReseted();
      }
  };

  return (
    <Card className="UserProfile mt-3 p-4">
      <Card.Title className='mb-3'>{t('prChangePassword')}</Card.Title>
      <Form onSubmit={handleSubmit}>         
        <Form.Group className="mb-3" controlId="oldPassword">
          <Form.Label className="small text-start">{t('prOldPass')}</Form.Label>
          <Form.Control
            type="password"
            className="form-control bg-light"
            name="oldPassword"
            value={passwordData.oldPassword}
            onChange={handleInputChange}
          />
        </Form.Group>
        
        <Form.Group className="mb-3" controlId="newPassword">
          <Form.Label className="small text-start">{t('prNewPass')}</Form.Label>
          <Form.Control
            type="password"
            className="form-control bg-light"
            name="newPassword"
            value={passwordData.newPassword}
            onChange={handleInputChange}
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="confirmPassword">
          <Form.Label className="small text-start">{t('prConfirmNewPass')}</Form.Label>
          <Form.Control
            type="password"
            className="form-control bg-light"
            name="confirmPassword"
            value={passwordData.confirmPassword}
            onChange={handleInputChange}
          />
        </Form.Group>

        <Stack direction="horizontal" className="justify-content-start">
          {error && <p className="text-danger fw-semibold">{error}</p>}
        </Stack>
        <Button variant="dark" className="mt-3" type="submit">
        {t('prSave')}
        </Button>
      </Form>
    </Card>
  );
}
